import React from 'react'
import { useFormikContext, ErrorMessage } from 'formik'
import { rationalNumbers } from 'Core/masks'

import { TextInputNew, Wrapper } from 'SRC/ui/FormElementsNew'

export const PriceDaily = () => {
	const formik = useFormikContext()

	React.useEffect(() => {
		if (Number(formik.initialValues.priceDaily) === -1) formik.setFieldValue('priceDaily', '', false)

		return () => { formik.setFieldValue('priceDaily', -1, false) }
	}, [])

	const error = formik.touched.priceDaily && formik.errors.priceDaily

	return (
		<Wrapper isError={error}>
			<TextInputNew
				id='priceDaily'
				name='priceDaily'
				title='Dnevno'
				isRequired
				value={formik.values.priceDaily}
				mask={rationalNumbers}
				measure='€'
				onChange={async textValue => {
					formik.setFieldValue('priceDaily', textValue, false)

					if (!formik.touched.priceDaily) formik.setFieldTouched('priceDaily', true)

					formik.setErrors({
						...formik.errors,
						priceDaily: formik.touched.priceDaily && [0, -1].includes(Number(textValue)) ? 'Popunite dnevnu cijenu' : undefined
					})
				}}
			/>

			<ErrorMessage
				name='priceDaily'
				render={msg => <span style={{ display: 'block', marginTop: 5 }} className='form-group__error-message'>{msg}</span>}
			/>
		</Wrapper>
	)
}
